var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$store.state.showCatSlider
      ? _c(
          "div",
          { staticClass: "catSlider", class: { fixed: _vm.fixed } },
          [
            _c(
              "v-slide-group",
              {
                attrs: {
                  "show-arrows": false,
                  "center-active": true,
                  mandatory: true,
                },
                model: {
                  value: _vm.model,
                  callback: function ($$v) {
                    _vm.model = $$v
                  },
                  expression: "model",
                },
              },
              _vm._l(_vm.cats, function (cat) {
                return _c("v-slide-item", {
                  key: cat.pId,
                  attrs: { value: cat.pId },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ active, toggle }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "prelative" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "sliderBtn titleFont text-none",
                                    attrs: {
                                      large: "",
                                      tile: "",
                                      "input-value": active,
                                      "active-class": "catActive",
                                    },
                                    on: {
                                      click: function ($event) {
                                        toggle()
                                        _vm.selectCat(cat)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(cat.categoryDE) + " ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }